import { DOWNLOAD_USER_REPORT, DOWNLOAD_USER_REPORT_SUCCESS, DOWNLOAD_USER_REPORT_ERROR, DOWNLOAD_USER_REPORT_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadUserReport = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_USER_REPORT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_USER_REPORT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_USER_REPORT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_USER_REPORT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadUserReport;
